const FRESHDESK_TICKET_URL = "https://karlstechnology.freshdesk.com/helpdesk/tickets/";

/** @param {Tickets_Object} ticket */
export const getTicketFinancial = (ticket) => ticket?.tickets_financialss?.[0] ?? null;

/** @param {number|undefined} paymentType */
export const formatPaymentType = (paymentType) => {
	if (paymentType === 1) return "C";
	if (paymentType === 2) return "";
	if (paymentType === 3) return "CC";
	if (paymentType) return "Send Invoice";
	return "";
};

/** @param {Tickets_Financials_Object|null} financial */
export const formatInvoiceTotal = (financial) => {
	if (!financial) return "";
	const labor = parseFloat(financial.labor_amount).toFixed(2);
	const virus = parseFloat(financial.virus_sales).toFixed(2);
	const parts = parseFloat(financial.parts_amount).toFixed(2);
	return `=${labor} + ${virus} + ${parts}`;
};

export const getFreshdeskTicketUrl = (freshTicket) => `${FRESHDESK_TICKET_URL}${freshTicket}`;

/** @param {number|undefined} paymentType */
export const isSendInvoice = (paymentType) => paymentType === 4;

/** @param {Tickets_Financials_Object|null} financial */
export const parseInvoiceTotalNumeric = (financial) => {
	if (!financial) return 0;
	const labor = parseFloat(financial.labor_amount) || 0;
	const virus = parseFloat(financial.virus_sales) || 0;
	const parts = parseFloat(financial.parts_amount) || 0;
	return labor + virus + parts;
};

/** @param {Tickets_Financials_Object|null} financial */
export const getCommissionAmount = (financial) => {
	if (!financial) return 0;
	const labor = parseFloat(financial.labor_amount) || 0;
	const virus = parseFloat(financial.virus_sales) || 0;
	return (labor + virus) / 125;
};
